"use client";

import { useEffect, useRef } from "react";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { selectIsAuthSuccessOrPerpetual, useAppSelector } from "@repo/global-store";
import { postMfLastVisitedFund } from "../../services/AMCService";

export type AmcPdpLastVisitedTrackerProps = {
  bseSchCode: string;
};

const AmcPdpLastVisitedTracker = ({ bseSchCode }: AmcPdpLastVisitedTrackerProps) => {
  const isLoggedIn = useAppSelector(selectIsAuthSuccessOrPerpetual);
  const trackedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isLoggedIn || !bseSchCode?.trim()) return;
    if (trackedRef.current === bseSchCode) return;

    trackedRef.current = bseSchCode;

    void (async () => {
      try {
        const { mobileNo } = await getSessionData();
        if (!mobileNo?.trim()) {
          trackedRef.current = null;
          return;
        }

        await postMfLastVisitedFund({
          bseSchCode,
          mobile: mobileNo.trim(),
        });
      } catch {
        trackedRef.current = null;
      }
    })();
  }, [bseSchCode, isLoggedIn]);

  return null;
};

export default AmcPdpLastVisitedTracker;
